import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { plotMap } from './plotConfig';
import { isEmpty } from 'lodash';
let MultiBehavior = class MultiBehavior extends Vue {
    hehaviorList = [];
    init(val) {
        const { taskType } = val?.query;
        const behavior = plotMap.get(taskType);
        if (!isEmpty(behavior)) {
            this.hehaviorList = behavior?.multipleRoi?.behavior;
        }
    }
    setBagColor(color) {
        return `backgroundColor:${color}`;
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], MultiBehavior.prototype, "init", null);
MultiBehavior = __decorate([
    Component({
        name: 'MultiBehavior',
        components: {},
        i18n: {
            messages: {
                en: {},
                zh: {}
            }
        }
    })
], MultiBehavior);
export default MultiBehavior;
